// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1inLn","validationTips":"StatementDescriptor_validationTips__3qPjz"};